import { getPlaceUrl, getRegionUrl } from '@domain/routes/urls';

interface IProps {
  countryId?: string;
  countryName?: string;
  placeName: string;
  placeSlug?: string;
  regionId?: string | null;
  regionName?: string | null;
}

/**
 * `getPlaceLinksString` returns a string with links to a region and country based on provided IDs and names.
 * It is mainly used in metadata.
 *
 * @param {Object} props - The properties object.
 * @param {string | null} [props.regionId] - The ID of the region (optional).
 * @param {string | null} [props.regionName] - The name of the region (optional).
 * @param {string} props.countryId - The ID of the country.
 * @param {string} props.countryName - The name of the country.
 *
 * @returns {JSX.Element} The rendered `LocationLinks` component.
 */
export const getPlaceLinksString = ({
  countryId,
  countryName,
  placeName,
  placeSlug,
  regionId,
  regionName,
}: IProps) => {
  if (!countryId || !regionId || !placeSlug || !countryName || !regionName) {
    return `${placeName}${regionId ? `, ${regionId}` : ''}`;
  }
  // nosemgrep: javascript.lang.security.html-in-template-string
  return `<a href="${getPlaceUrl(countryId, regionId, placeSlug)}">${placeName}</a>, <a href="${getRegionUrl(countryId, regionId, countryName, regionName)}">${regionId}</a>`;
};
